import React, { Component } from 'react';

import HelpIcon from '@mui/icons-material/Help';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { ToggleButton, Box, Pagination } from '@mui/material';
import { useGridApiContext, useGridState } from '@mui/x-data-grid';

function CustomPaginationComponent(props) {
    const apiRef = useGridApiContext()
    const [state] = useGridState(apiRef)
    return (
        state.pagination.pageCount === 1? null : 
        <Pagination
            color="primary"
            size="small"
            
            sx={{
                color: "#d01a62",
                '.MuiPaginationItem-previousNext': { width: 18, height: 18, color: '#d01a62', opacity: 1 },
                '.Mui-disabled': { color: 'black', opacity: 0.3 }
            }}
            siblingCount={window.screen.width < 992? 0 : 2}
            boundaryCount={window.screen.width < 992? 0 : 1}
            // showFirstButton={state.pagination.page < 1? false : true}
            // showLastButton={state.pagination.page + 1 < state.pagination.pageCount? true : false}
            count={state.pagination.pageCount}
            page={state.pagination.page + 1}
            onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
    )
}

function MinimalFooterComponent(props) {
    const apiRef = useGridApiContext()
    const [state] = useGridState(apiRef)
    return (
        state.pagination.pageCount === 1 ? null :
        <Box sx={{display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', justifyContent: 'flex-end', minHeight: '60px'}}>
            <CustomPaginationComponent />
        </Box>
    )
}

class CustomFooter extends Component { 
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Box sx={{display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', justifyContent: 'flex-end', minHeight: '60px'}}>
                {this.props.displayHelp === undefined && this.props.toggleHelp === undefined? null : 
                    <ToggleButton
                        size="small"
                        width="24px"
                        style={{margin: '8px'}}
                        value="displayHelp"
                        selected={this.props.displayHelp}
                        onChange={this.props.toggleHelp}
                    >
                        {this.props.displayHelp? <HelpIcon sx={{width: 18, height: 18}} /> : <HelpIcon sx={{ width: 18, height: 18, color: '#d01a62' }} />}
                    </ToggleButton>
                }
                {this.props.refreshing === undefined || this.props.toggleRefresh === undefined? null : 
                    <ToggleButton
                        size="small"
                        width="24px"
                        style={{margin: '8px'}}
                        value="refreshing"
                        selected={this.props.refreshing}
                        onChange={this.props.toggleRefresh}
                    >
                        {this.props.refreshing? <PauseIcon sx={{width: 18, height: 18}} /> : <PlayArrowIcon sx={{ width: 18, height: 18, color: '#d01a62' }} />}
                    </ToggleButton>
                }
                <p style={{
                    alignSelf: 'flex-start', 
                    flex: 1, 
                    margin: 'auto',
                    paddingLeft: '16px',
                    textAlign: 'left', 
                    fontSize: 16,
                }}>
                    {this.props.refreshing? (window.screen.width < 992? "" : "Refreshing every ") + this.props.timer : (window.screen.width < 992? "" : (this.props.pausedAt? this.props.pausedAt: ""))}
                </p>
                <CustomPaginationComponent />
            </Box>
        )
    }
}

export default CustomFooter;